import './scripts/scripts';
import './scripts/animations';
import './styles/tailwind.css';
